export const styles = theme => ({
    columnTitle: {
        flexBasis: '40%',
    },
    columnControl: {
        flexBasis: '60%',
    },
    alignRight: {
        textAlign: 'right',
    },
    alignCenter: {
        textAlign: 'center',
    },
    panel: {
        border: '1px solid rgba(24,32,44,0.3)',
    },
    selectControl: {
        width: '100%',
    },
    button: {
        marginLeft: '4px',
    },
    widthMax: {
        width: '100%',
    },
    cursorPointer: {
      cursor: 'pointer',
    },
    divider: {
        backgroundColor: '#404854',
        width: '100%',
    },
    tableBorder: {
        '& th, td': {
            border: '1px solid rgba(24,32,44,0.3)',
        }
    },
    helperTooltipIconSize: {
        fontSize: 13,
        marginBottom: -1,
    },
    helperTooltipTextSize: {
        fontSize: 13
    }

});